"use client"

import {RefObject, useEffect, useRef, useState} from 'react';
import BannerComponent from './BannerComponent';
import OverlayComponent from './OverlayComponent';
import classNames from 'classnames';
import {observer} from "mobx-react";
import {useShouldDisplayHero} from "../../../../hooks/useShouldDisplayHero";

const localStorageKeys = {
    'banner': 'dismissedBanners',
    'overlay': 'dismissedOverlays',
    'notificationOnly': 'dismissedNotification',
};

const NotificationContainer = observer((props: {
    notifications: string,
    shouldShowOverlay: boolean,
    shouldShowBanner: boolean,
}) => {
    const {notifications = JSON.stringify([])} = props;

    const overlayNotifications: RefObject<Array<{ type: "banner" | "overlay" }>> = useRef([]);
    const bannerNotifications: RefObject<Array<{ type: "banner" | "overlay" }>> = useRef([]);

    const [shouldShowBanner, setShouldShowBanner] = useState(false);
    const [shouldShowOverlay, setShouldShowOverlay] = useState(false);
    const heroIsEnabled = useShouldDisplayHero();

    useEffect(() => {
        // check local storage for both alert types
        overlayNotifications.current = [];
        bannerNotifications.current = [];

        const n = JSON.parse(notifications)

        let showOverlay = false, showBanner = false,
            dismissedIds = {},
            storageKey;

        Object.keys(localStorageKeys).forEach((notificationType) => {
            storageKey = localStorageKeys[notificationType];
            dismissedIds[notificationType] = JSON.parse(sessionStorage.getItem(storageKey) as string) || [];
        });

        n.map((notification) => {
            switch (notification.type) {
                case 'overlay':
                    overlayNotifications.current.push(notification);
                    break;

                case 'banner':
                    bannerNotifications.current.push(notification);
                    break;
            }

            if (notification.type && dismissedIds[notification.type].indexOf(notification.id) === -1) {
                if (notification.type === "banner") {
                    showBanner = true;
                } else {
                    showOverlay = true;
                }
            }
        });

        setShouldShowOverlay(showOverlay);
        setShouldShowBanner(showBanner);
    }, []);

    function handleDismiss(props) {
        const {alerts, type} = props;

        sessionStorage.setItem(localStorageKeys[type], JSON.stringify(alerts.map((alert) => alert.id)));

        if (type === "banner") {
            setShouldShowBanner(false);
        } else {
            setShouldShowOverlay(false);
        }
    }

    let overlay,
        banner;

    if (shouldShowBanner && props.shouldShowBanner) {
        banner = <BannerComponent alerts={bannerNotifications.current}
                                  handleDismiss={handleDismiss}/>;
    }

    if (shouldShowOverlay && props.shouldShowOverlay) {
        overlay = <OverlayComponent alerts={overlayNotifications.current} handleDismiss={handleDismiss}/>;
    }

    const notificationClassName = classNames({
        "sb-top-drawer-container": true,
        "sb-notification": true,
        "open": true,
    })

    const notificationContainerClassName = classNames({
        "notification-container": true,
        "notification-container-with-hero": heroIsEnabled,
        "banner-notification-container": shouldShowBanner && props.shouldShowBanner,
        "overlay-notification-container": shouldShowOverlay && props.shouldShowOverlay,
    })

    return (
        <div className={notificationContainerClassName}>
            <div id="sb-notification-drawer" className={"sb-top-drawer sb-notification-drawer"} style={{visibility: "visible"}}>
                <div className={notificationClassName}>
                    {banner}
                    {overlay}
                </div>
            </div>
        </div>
    )
})

export default NotificationContainer
